import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { resetPassword, verifyResetToken } from 'js/actions/account-actions';
import {
  storePasswordCredential,
  waitForNextPaint,
} from 'js/utils/credentials';

import PasswordResetRouteComponent from '../components/PasswordResetRouteComponent';

const PasswordResetRouteContainer = ({
  resetPassword,
  verifyResetToken,
  history,
  match: {
    params: { resetKey },
  },
}) => {
  const [tokenVerified, setTokenVerified] = useState(null);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    verifyResetToken(resetKey)
      .then((data) => {
        setEmail(data?.email || null);
        setTokenVerified(true);
      })
      .catch(() => {
        setEmail(null);
        setTokenVerified(false);
      });
  }, [resetKey, verifyResetToken, setTokenVerified]);

  const handleReset = useCallback(
    async ({ password }, formEl) => {
      try {
        const me = await resetPassword(resetKey, password);
        const username = email || me?.username;
        await storePasswordCredential(
          formEl || {
            id: username,
            password,
            name: me?.display_name || username,
          }
        );
        await waitForNextPaint();
        history.push('/dashboard');
      } catch {
        setTokenVerified(false);
      }
    },
    [resetKey, resetPassword, history, setTokenVerified, email]
  );

  return (
    <PasswordResetRouteComponent
      onReset={handleReset}
      tokenVerified={tokenVerified}
      email={email}
    />
  );
};

export default connect(null, {
  resetPassword,
  verifyResetToken,
})(PasswordResetRouteContainer);
